import React, { useState } from 'react';
import ReactTable from 'react-table'
import {isAuthenticated} from "../../store/action/auth";
import axios from "axios";
import {API} from "../../config";

const AdminPostalCodeTable = props => {
    const { token } = isAuthenticated();

    const columns = [{
        Header: '#',
        Cell: ({row,original}) => row._index+1,
        maxWidth: 40,
        className:'text-center',
        headerClassName: 'text-center'
    },{
        Header: 'Id Kode Post',
        accessor: 'id',
    },{
        Header: 'Kode Pos Salah',
        accessor: 'wrongPostalCode',
    },{
        Header: 'Kode Pos Benar',
        accessor: 'correctPostalCode',
    },{
        Header: 'Hapus',
        accessor: 'note',
        Cell: ({row, original}) => deleteCell(original)
    }];

    const onClickDelete = async (og) => {
        try {
            let data = { delete_postal_code:og.correctPostalCode };
            const res = await axios.delete(`${API}/v1/admin/correctors/postal_codes`,{
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    Authorization: `Bearer ${token}`
                },
                data
            });

            if(res.data.success) {
                alert(res.data.message);
                window.location.reload()
            } else {
                alert(res.data.error);
            }
        } catch (e) {
            console.log (e);
            return alert(e.message)
        }
    };

    const deleteCell = (og) => {
      return (
          <span className="badge badge-primary border-primary border pointer" onClick={() => onClickDelete(og)}>
              Delete
          </span>
      )
    };

    return (
        <div>
            <ReactTable
                data={props.data}
                columns={columns}
                defaultPageSize={50}
                filterable
                loading={props.loading}
                className="-striped -highlight"
            />
        </div>
    )
};

export default AdminPostalCodeTable;
